<template>
  <svg
    class="icon icon-html"
    xmlns="http://www.w3.org/2000/svg"
    baseProfile="tiny"
    version="1.2"
    viewBox="0 0 22 28"
    :width="width"
    :height="width"
  >
    <title>html5</title>
    <path d="M17.656 9.328l0.25-2.734h-13.813l0.734 8.344h9.562l-0.344 3.563-3.078 0.828-3.063-0.828-0.203-2.188h-2.734l0.344 4.344 5.656 1.563h0.063v-0.016l5.609-1.547 0.781-8.5h-10.063l-0.234-2.828h10.531zM0 2h22l-2 22.469-9.031 2.531-8.969-2.531z"></path>
  </svg>
</template>

<script>
export default {
  name: 'htmlIcon',
  props: {
    width: {
      type: Number,
      default: 50,
      required: false
    }
  }
}
</script>
